import { render } from "./AddPerson.vue?vue&type=template&id=4a496f72&ts=true"
import script from "./AddPerson.vue?vue&type=script&lang=ts"
export * from "./AddPerson.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__